module.exports = __webpack_public_path__ + "img/icon (20).d2f1d081.png";